// cache-refresh 2026-07-13
// app.js hier importeren = de enige module-instantie (zelfde URL als pdp/plp/home)
import './app.js?v=32';
import { t } from './i18n.js?v=13';
// Injects header, trust strip, footer, cart drawer into every page.
// Reads body[data-surface] to flip header/wordmark colours.

const ICONS = {
  search: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
  bag:    '<svg viewBox="0 0 24 24"><path d="M6 7h12l-1 13H7L6 7z"/><path d="M9 7a3 3 0 1 1 6 0"/></svg>',
  menu:   '<svg viewBox="0 0 24 24"><path d="M4 6h16M4 12h16M4 18h16"/></svg>',
  close:  '<svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>',
  globe:  '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></svg>',
};

function injectTrustStrip() {
  const el = document.getElementById('trust-strip');
  if (!el) return;
  el.outerHTML = `
    <div class="trust-strip">
      <div class="trust-strip__items" id="trust-items">
        <span class="is-on">${t('trust_1')}</span>
        <span>${t('trust_2')}</span>
        <span>${t('trust_3')}</span>
      </div>
    </div>
  `;
  // Mobiel: één USP tegelijk, rustig roterend (desktop toont alles naast elkaar
  // via CSS en negeert .is-on). Reduced motion = statisch de eerste tonen.
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const items = document.querySelectorAll('#trust-items > span');
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-on');
      i = (i + 1) % items.length;
      items[i].classList.add('is-on');
    }, 3500);
  }
}

// Taal-switcher: toont huidige taal, klik = dropdown naar de gepubliceerde talen.
// Shopify Markets herschrijft de URL per locale (/, /en, /de, ...).
// Mini-vlaggen als inline SVG (emoji-vlaggen renderen niet op Windows)
const FLAGS = {
  nl: '<svg class="flag" viewBox="0 0 60 40"><rect width="60" height="40" fill="#21468B"/><rect width="60" height="26.7" fill="#fff"/><rect width="60" height="13.3" fill="#AE1C28"/></svg>',
  en: '<svg class="flag" viewBox="0 0 60 40"><rect width="60" height="40" fill="#012169"/><path d="M0 0 60 40M60 0 0 40" stroke="#fff" stroke-width="8"/><path d="M0 0 60 40M60 0 0 40" stroke="#C8102E" stroke-width="4"/><path d="M30 0v40M0 20h60" stroke="#fff" stroke-width="13"/><path d="M30 0v40M0 20h60" stroke="#C8102E" stroke-width="8"/></svg>',
  de: '<svg class="flag" viewBox="0 0 60 40"><rect width="60" height="40" fill="#FFCE00"/><rect width="60" height="26.7" fill="#DD0000"/><rect width="60" height="13.3" fill="#000"/></svg>',
  fr: '<svg class="flag" viewBox="0 0 60 40"><rect width="60" height="40" fill="#ED2939"/><rect width="40" height="40" fill="#fff"/><rect width="20" height="40" fill="#002395"/></svg>',
  es: '<svg class="flag" viewBox="0 0 60 40"><rect width="60" height="40" fill="#AA151B"/><rect y="10" width="60" height="20" fill="#F1BF00"/></svg>',
};
const LOCALES = [
  { code: 'nl', label: 'NL', path: '' },
  { code: 'en', label: 'EN', path: '/en' },
  { code: 'de', label: 'DE', path: '/de' },
  { code: 'fr', label: 'FR', path: '/fr' },
  { code: 'es', label: 'ES', path: '/es' },
];
// Vertaalde routes uit Liquid (window.ROUTES), met het oude NL-pad als terugval.
const R_ABOUT = (window.ROUTES && window.ROUTES.about) || null;
const R_BLOG  = (window.ROUTES && window.ROUTES.blog)  || null;
const LP = (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase() === 'nl' ? '' : '/' + (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
function currentLocale() {
  return (document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
}
function langSwitchHTML() {
  const cur = currentLocale();
  const items = langItemsHTML(cur);
  return `
    <div class="lang-wrap">
      <button class="lang-switch" aria-label="${t('aria_lang')}: ${cur.toUpperCase()}" aria-haspopup="true" aria-expanded="false" data-action="toggle-lang">${FLAGS[cur] || cur.toUpperCase()}</button>
      <div class="lang-menu" id="lang-menu" hidden>${items}</div>
    </div>
  `;
}
// Doel per taal: de hreflang-alternates die Shopify in de head zet wijzen naar de
// VERTAALDE URL (vertaalde handles). Het oude "prefix + NL-pad" gaf altijd een 301.
function altHref(code, path) {
  const a = document.querySelector(`link[rel="alternate"][hreflang="${code}"]`)
         || document.querySelector(`link[rel="alternate"][hreflang^="${code}-"]`);
  if (a && a.href) { try { const u = new URL(a.href); return u.pathname + u.search; } catch (e) {} }
  return path + pathWithoutLocale();
}
function langItemsHTML(cur) {
  return LOCALES.map(l =>
    `<a href="${altHref(l.code, l.path)}" hreflang="${l.code}" ${l.code === cur ? 'aria-current="true"' : ''}>${FLAGS[l.code] || ''}<span>${l.label}</span></a>`
  ).join('');
}
function pathWithoutLocale() {
  let p = location.pathname;
  for (const l of LOCALES) {
    if (l.path && p.startsWith(l.path + '/')) return p.slice(l.path.length);
    if (l.path && p === l.path) return '/';
  }
  return p;
}

function injectHeader() {
  const el = document.getElementById('site-header');
  if (!el) return;
  el.outerHTML = `
    <header class="site-header" id="site-header">
      <div class="header-inner">
        <a class="wordmark" href="${LP}/"><span class="wm-num">25</span><span class="wm-name">ART<em>STREET</em></span></a>
        <nav class="header-nav" aria-label="${t('aria_nav')}">
          <a href="${LP}/collections/all">${t('nav_posters')}</a>
          <a href="${LP}/collections">${t('nav_collections')}</a>
          <a href="${R_ABOUT || LP + '/pages/over-ons'}">${t('nav_about')}</a>
          <a href="${R_BLOG || LP + '/blogs/nieuws'}">${t('nav_tips')}</a>
        </nav>
        <div class="header-utils">
          <button class="icon-btn menu-btn" aria-label="${t('aria_menu')}" data-action="open-menu">${ICONS.menu}</button>
          <button class="icon-btn" aria-label="${t('aria_search')}" data-action="open-search">${ICONS.search}</button>
          ${langSwitchHTML()}
          <button class="icon-btn icon-btn--cart" aria-label="${t('aria_cart')}" data-action="open-cart">
            ${ICONS.bag}
            <span class="cart-count tabular" id="cart-count" hidden>0</span>
          </button>
          <a class="btn btn--primary header-cta" href="${LP}/collections/all">${t('shop_now')}</a>
        </div>
      </div>
    </header>
  `;
  // dropdown-gedrag
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-action="toggle-lang"]');
    const menu = document.getElementById('lang-menu');
    if (!menu) return;
    if (btn) {
      const open = !menu.hidden;
      menu.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
    } else if (!e.target.closest('.lang-wrap')) {
      menu.hidden = true;
    }
  });
}

function injectFooter() {
  const el = document.getElementById('site-footer');
  if (!el) return;
  // Footer wordt server-side gerenderd (snippets/site-footer.liquid) voor SEO;
  // alleen injecteren als fallback wanneer de SSR-versie ontbreekt.
  if (el.dataset && el.dataset.ssr) return;
  el.outerHTML = `
    <footer class="site-footer" id="site-footer">
      <div class="container">
        <div class="footer-grid">
          <div class="footer-brand">
            <a class="wordmark wordmark--lg" href="${LP}/"><span class="wm-num">25</span><span class="wm-name">ART<em>STREET</em></span></a>
            <p>${t('f_brand')}</p>
          </div>
          <div class="footer-col">
            <h4>${t('f_posters')}</h4>
            <ul>
              <li><a href="${LP}/collections/all">${t('f_all')}</a></li>
              <li><a href="${LP}/collections/nieuw">${t('f_new')}</a></li>
              <li><a href="${LP}/collections/bestsellers">${t('f_best')}</a></li>
              <li><a href="${LP}/collections/sale">${t('f_sale')}</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>${t('f_about')}</h4>
            <ul>
              <li><a href="${R_ABOUT || LP + '/pages/over-ons'}">${t('f_studio')}</a></li>
              <li><a href="#">${t('f_print')}</a></li>
              <li><a href="#">${t('f_sustain')}</a></li>
              <li><a href="${R_BLOG || LP + '/blogs/nieuws'}">${t('f_tips')}</a></li>
            </ul>
          </div>
          <div class="footer-col">
            <h4>${t('f_help')}</h4>
            <ul>
              <li><a href="#">${t('f_shipping')}</a></li>
              <li><a href="#">${t('f_returns')}</a></li>
              <li><a href="#">${t('f_faq')}</a></li>
              <li><a href="#">${t('f_contact')}</a></li>
            </ul>
          </div>
        </div>

        <div class="footer-newsletter">
          <div>
            <h4 style="font-size: var(--fs-h3); color: var(--white); letter-spacing: var(--tr-h3); font-weight: 600; text-transform: none;">${t('f_nl_title')}</h4>
            <p style="color: var(--mute); margin-top: 6px;">${t('f_nl_sub')}</p>
          </div>
          <form onsubmit="event.preventDefault(); this.querySelector('button').textContent='${t('f_nl_thanks')}'">
            <input class="input" type="email" placeholder="${t('f_nl_placeholder')}" required />
            <button class="btn btn--primary" type="submit">${t('f_nl_submit')}</button>
          </form>
        </div>

        <div class="footer-bottom">
          <p>${t('f_copyright')}</p>
          <div class="sustainability">
            <span>FSC</span><span>GREENGUARD</span><span>${t('f_nl_studio')}</span>
          </div>
        </div>
      </div>
    </footer>
  `;
}

function injectCart() {
  const el = document.getElementById('cart-drawer');
  if (!el) return;
  el.outerHTML = `
    <div class="cart-scrim" id="cart-scrim" data-action="close-cart"></div>
    <div class="cart-drawer" id="cart-drawer" role="dialog" aria-modal="true" aria-label="${t('aria_cart')}">
      <div class="cart-head">
        <h2>${t('cart_title')}</h2>
        <button class="icon-btn" aria-label="${t('aria_close')}" data-action="close-cart">${ICONS.close}</button>
      </div>
      <div class="cart-body" id="cart-body">
        <p class="cart-empty">${t('cart_empty')} <a href="${LP}/collections/all">${t('cart_empty_cta')}</a></p>
      </div>
      <div class="cart-foot" id="cart-foot" hidden>
        <div class="cart-nudge" id="cart-nudge" hidden></div>
        <div class="fship">
          <div class="fship__track"><div class="fship__fill" id="fship-fill" style="width: 0%;"></div></div>
          <span id="fship-label">${t('cart_ship_left', { amount: '€30,00' })}</span>
        </div>
        <div class="cart-savings" id="cart-savings" hidden></div>
        <div class="totals">
          <span>${t('cart_subtotal')}</span><strong id="cart-total">€0,00</strong>
        </div>
        <button class="btn btn--primary" data-action="checkout-now">${t('cart_checkout')}</button>
        <button class="btn btn--secondary cart-continue" data-action="close-cart">${t('cart_continue')}</button>
        <p class="cart-trust">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          ${t('cart_trust')}
        </p>
      </div>
    </div>
  `;
}

function injectMenuDrawer() {
  if (document.getElementById('menu-drawer')) return;
  const node = document.createElement('div');
  node.id = 'menu-drawer';
  node.className = 'menu-drawer';
  node.innerHTML = `
    <div class="menu-drawer__head">
      <a class="wordmark" href="${LP}/"><span class="wm-num">25</span><span class="wm-name">ART<em>STREET</em></span></a>
      <button class="icon-btn" aria-label="${t('aria_close')}" data-action="close-menu">${ICONS.close}</button>
    </div>
    <nav class="menu-drawer__body" aria-label="${t('aria_nav_mobile')}">
      <a href="${LP}/collections/all">${t('nav_posters')}</a>
      <a href="${LP}/collections">${t('nav_collections')}</a>
      <a href="${R_ABOUT || LP + '/pages/over-ons'}">${t('nav_about')}</a>
      <a href="${R_BLOG || LP + '/blogs/nieuws'}">${t('nav_tips')}</a>
    </nav>
    <div class="menu-drawer__langs" aria-label="${t('aria_lang')}">${langItemsHTML(currentLocale())}</div>
  `;
  document.body.appendChild(node);
}

function injectStickyBar() {
  // Skip on PDP — that page has its own sticky add-to-cart
  if (document.body.dataset.skipSticky === 'true' || location.pathname.includes('/products/')) return;
  if (document.getElementById('sticky-bar')) return;
  const node = document.createElement('div');
  node.id = 'sticky-bar';
  node.className = 'sticky-bar';
  node.innerHTML = `
    <div class="sticky-bar__inner">
      <div class="sticky-bar__copy">
        <small>${t('sticky_small')}</small>
        <strong>${t('sticky_strong')}</strong>
      </div>
      <a class="btn btn--primary" href="${LP}/collections/all">${t('shop_now')}</a>
    </div>
  `;
  document.body.appendChild(node);

  // Reveal after first scroll past hero
  const reveal = () => {
    if (window.scrollY > 320) {
      node.classList.add('is-visible');
    } else {
      node.classList.remove('is-visible');
    }
  };
  window.addEventListener('scroll', reveal, { passive: true });
}

// Zoek-overlay: klik op het vergrootglas opent een paneel met live
// suggesties via Shopify's predictive search (/search/suggest.json);
// Enter gaat naar de volledige resultatenpagina (templates/search.liquid).
// De knop stond er vanaf de bouw, maar had nooit gedrag (Wes 31-08).
function injectSearchOverlay() {
  if (document.getElementById('search-overlay')) return;
  const node = document.createElement('div');
  node.id = 'search-overlay';
  node.className = 'search-overlay';
  node.hidden = true;
  node.innerHTML = `
    <div class="search-overlay__scrim" data-action="close-search"></div>
    <div class="search-overlay__panel" role="dialog" aria-modal="true" aria-label="${t('aria_search')}">
      <form class="search-overlay__form" action="${LP}/search" method="get" role="search">
        <input class="search-overlay__input" type="search" name="q" autocomplete="off"
               placeholder="${t('search_placeholder')}" aria-label="${t('aria_search')}" />
        <button class="icon-btn" type="button" aria-label="${t('aria_close')}" data-action="close-search">${ICONS.close}</button>
      </form>
      <div class="search-overlay__results" id="search-results" hidden></div>
    </div>
  `;
  document.body.appendChild(node);

  const overlay = node;
  const input = node.querySelector('.search-overlay__input');
  const results = node.querySelector('#search-results');
  const open = () => { overlay.hidden = false; document.body.classList.add('no-scroll'); setTimeout(() => input.focus(), 30); };
  const close = () => { overlay.hidden = true; document.body.classList.remove('no-scroll'); };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-action="open-search"]')) { e.preventDefault(); open(); }
    if (e.target.closest('[data-action="close-search"]')) close();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !overlay.hidden) close(); });

  const geld = (p) => '€ ' + String(p).replace('.', ',');
  let timer = null, laatste = '';
  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(timer);
    if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
    timer = setTimeout(async () => {
      if (q === laatste) return;
      laatste = q;
      try {
        const r = await fetch(`${LP}/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8`);
        const d = await r.json();
        const prods = d.resources?.results?.products ?? [];
        if (!prods.length) {
          results.innerHTML = `<p class="search-overlay__none">${t('search_none')} “${q.replace(/</g, '&lt;')}”</p>`;
          results.hidden = false;
          return;
        }
        results.innerHTML = prods.map(p => `
          <a class="search-overlay__item" href="${p.url}">
            <img src="${(p.featured_image && p.featured_image.url) ? p.featured_image.url + '&width=120' : ''}" alt="" loading="lazy" />
            <span class="search-overlay__title">${p.title}</span>
            <span class="search-overlay__price tabular">${geld(p.price)}</span>
          </a>`).join('')
          + `<a class="search-overlay__all" href="${LP}/search?q=${encodeURIComponent(q)}">${t('search_all')} →</a>`;
        results.hidden = false;
      } catch (_) { /* suggesties zijn nice-to-have; Enter werkt altijd */ }
    }, 250);
  });
}

injectTrustStrip();
injectHeader();
injectFooter();
injectCart();
injectMenuDrawer();
injectSearchOverlay();
injectStickyBar();

document.documentElement.dispatchEvent(new CustomEvent('partials:ready'));
